import { useMutation, useQueryClient } from 'react-query';
import { formatISO, parse } from 'date-fns';
import { putWithHeaders } from 'Core/utils/platformApi';
import cacheKeys from 'Core/hooks/queries/cacheKeys';
import { getAppConfig } from 'Core/config/appConfig';

const FORTIVA_OFFER_DEFAULTS = {
  auto_pay: 'false',
  default_waived_interest: 'false',
  payment_date: 22,
};

const FORTIVA_PRODUCT_DEFAULTS = {
  type: 'Medical Product',
  description: 'Hearing Aids',
  serial_number: null,
};

export default function useUpdateOffer() {
  const queryClient = useQueryClient();

  return useMutation(
    ({ offerId, additionalPayment, financingDownPayment, deliveryDate, processSale }) => {
      const { dateFormat } = getAppConfig();
      const isoDeliveryDate = formatISO(parse(deliveryDate, dateFormat, new Date()), {
        representation: 'date',
      });

      const payload = {
        ...FORTIVA_OFFER_DEFAULTS,
        offer_id: offerId,
        process_sale: processSale,
        additional_payment: additionalPayment,
        financing_down_payment: financingDownPayment,
        products: [
          {
            ...FORTIVA_PRODUCT_DEFAULTS,
            delivery_date: isoDeliveryDate,
          },
        ],
      };

      return putWithHeaders(`/financing/update-offer`, payload);
    },
    {
      throwOnError: true,
      retry: 3,
      onSuccess: () => {
        queryClient.removeQueries(cacheKeys.financingNextStep);
        return queryClient.invalidateQueries(cacheKeys.financingNextStep);
      },
    }
  );
}
